const translation = {
  errorBoundary: {
    title: 'Bir şeyler ters gitti',
    description: 'Bu sayfa görüntülenemedi. Verileriniz değiştirilmedi. Tekrar deneyin veya sayfayı yeniden yükleyin.',
    offlineTitle: 'Platforma ulaşamıyoruz',
    offlineDescription: 'Platform bağlantısı kurulamadı. İnternet bağlantınızı kontrol edip tekrar deneyin.',
    retry: 'Tekrar dene',
    reload: 'Sayfayı yenile',
  },
  notifications: {
    empty: 'Yeni bildirim yok',
    clearAll: 'Tümünü temizle',
    clearAllConfirm: 'Tüm bildirimler temizlensin mi? Bu işlem geri alınamaz.',
    clearAllFailed: 'Bildirimler temizlenemedi',
    markReadFailed: 'Bildirim okundu olarak işaretlenemedi',
    delete: 'Bildirimi sil',
    deleteFailed: 'Bildirim silinemedi',
    reminderTitle: 'Ölçüm süresi yaklaşıyor',
    reminderBody: '{{programme}} için {{measurement}} kaydetme zamanı yaklaşıyor.',
    cleared: 'Bildirimler temizlendi',
    deleted: 'Bildirim silindi',
  },
  dataGrid: {
    noResultsFound: 'Sonuç bulunamadı',
    selectAll: 'Tümünü seç',
    selectRow: '{{name}} seç',
    rowLabel: 'satır {{id}}',
    ascending: 'Artan',
    descending: 'Azalan',
    sortByColumn: '{{column}} sütununa göre sırala ({{direction}})',
  },
  manageUsers: {
    title: 'Kuruluş üyeleri',
    subtitle: 'Kuruluşunuzdaki kişiler ve burada ne oldukları.',
    nameColumn: 'Ad',
    emailColumn: 'E-posta',
    rolesColumn: 'Roller',
    rolesPlaceholder: 'Rol ekle',
    rolesSaved: 'Roller güncellendi',
    rolesFailed: 'Roller güncellenemedi',
    filterLabel: 'Rol',
    filterAll: 'Tüm roller',
    filterNone: 'Rolsüz',
    noTenantNotice: 'Üyeler kuruluş bazında listelenir ve bu hesap bir kuruluşa ait değil.',
    noTenantTitle: 'Henüz kuruluş yok',
  },
      navGroups: {
        general: 'Genel',
        programmes: 'Programlar',
        mySettings: 'Ayarlar',
      },
      navigation: {
    ownEnvironment: 'Kendi ortamım',
    platformEnvironment: 'Platform yönetimi',
    switchEnvironment: 'Ortam değiştir',
    manageUsers: 'Kuruluş üyeleri',
        dashboard: 'Panom',
        foodTracking: 'Beslenme Takibi',
        activity: 'Aktivite',
        sleep: 'Uyku',
        weightBmi: 'Kilo/BMI',
        wellnessValues: 'Sağlık Değerleri',
        progress: 'İlerleme',
        insights: 'Öngörüler',
        myCommunity: 'Topluluğum',
        coaches: 'Koçlar',
        coaching: 'Koçluk',
        myProgrammes: 'Programlarım',
        programs: 'Programlar',
        researchData: 'Araştırma Verileri',
        education: 'Eğitim',
        analytics: 'Analitik',
        billing: 'Faturalama',
        shareData: 'Veri Paylaş',
        settings: 'Dil ve bölge',
        profile: 'Profilim',
        logout: 'Çıkış',
        masterData: 'Ana Veri',
        metabolicMeasurements: 'Ölçümlerim',
        weeklyData: 'Haftalık Veri',
        tenantSettings: 'Tenant Ayarları',
        dataManagement: 'Veri Ayarları',
        manageProgrammes: 'Program Ayarları',
        manageProgrammeMeasurements: 'Program Verileri',
        manageRoles: 'Roller',
        dataPermissions: 'Veri izinleri',
        dataProviders: 'Veri kaynakları',
        adminDataProviders: 'Tüm FHIR sunucuları',
        uploadPDF: 'PDF Yükle',
        savedDocuments: 'Belgelerim',
        pinSidebar: 'Yan çubuğu sabitle',
        unpinSidebar: 'Yan çubuğu serbest bırak',
      },
      devLogin: {
        subtitle: 'Yerel geliştirme — kimlik doğrulama atlandı',
        roles: {
          globalAdmin: 'Genel yönetici',
          tenantAdmin: 'Kiracı yöneticisi',
          coach: 'Koç',
          member: 'Üye',
          remoteMember: 'Uzak üye',
        },
      },
      brand: {
        loading: 'Yükleniyor',
      },
      auth: {
        platformName: 'My Lifestyle Platform',
        poweredBy: 'Stichting Je Leefstijl Als Medicijn tarafından sunulmaktadır',
        platformLogin: 'Platform Girişi',
        password: 'Şifre',
        signIn: 'Giriş Yap',
        signUp: 'Kayıt Ol',
        forgotPassword: 'Şifremi unuttum?',
        requestAccess: 'Erişim talep et',
        demoMode: 'Demo Modu - Herhangi bir kimlik bilgisi kullanın',
        demoDescription: 'Eksiksiz yaşam tarzı sağlık kontrol panelinize erişin',
        loginSuccess: 'Giriş başarılı! Yönlendiriliyor...',
        sessionExpired: {
          title: 'Oturumunuzun süresi doldu',
          message: 'Verilerinizi korumak için oturumunuz otomatik olarak kapatıldı. Devam etmek için tekrar giriş yapın.',
          signIn: 'Tekrar giriş yap',
          dismiss: 'Daha sonra',
        },
      },
      dashboard: {
        refreshData: 'Verileri yenile',
        lastSynced: 'Son senkronizasyon {{time}}',
        justSynced: 'Az önce senkronize edildi',
        signInRequired: 'Gösterge panelini görüntülemek için giriş yapmanız gerekiyor.',
        unableToLoad: 'Gösterge paneli verileri yüklenemiyor.',
        activeProgrammes: 'Aktif Programlar',
        programmes: 'Programlar',
        trackedMeasurements: 'Takip edilen ölçümler',
        targetsConfigured: 'Yapılandırılmış hedefler',
        dateAxisLabel: 'Tarih',
        measurementTrends: 'Ölçüm eğilimleri',
        measurementTrendsSubtitle: 'Tüm ölçümleri birlikte keşfetmek için yığılmış görünüm.',
        timeRange: 'Zaman aralığı:',
        oneYear: '1 yıl',
        days: '{{count}}g',
        noMeasurementData: 'Henüz ölçüm verisi yok',
        noMeasurementDataSubtitle: 'Yeni veri noktaları geldiğinde, zaman çizelgesi otomatik olarak güncellenecektir.',
        programmeTargets: 'Program hedefleri',
        programmeTargetsSubtitle: 'Hedefler program yöneticiniz tarafından belirlenir ve burada referans olarak gösterilir.',
        noProgrammeMeasurements: 'Henüz hiçbir program ölçümü mevcut değil.',
        latestValue: 'Son değer',
        targetRange: 'Hedef aralığı',
        noMeasurementRecorded: 'Henüz kayıtlı ölçüm yok',
        onTarget: 'Hedefte',
        needsAttention: 'Dikkat gerektirir',
        noTargetSet: 'Hedef belirlenmedi',
        min: 'Min: {{value}} {{unit}}',
        max: 'Maks: {{value}} {{unit}}',
        rangeTarget: '{{min}} - {{max}} {{unit}}',
        scopeFrom: 'Ölçümleri şu tarihten itibaren göster',
        scopeTo: 'Ölçümleri bu tarih dahil olmak üzere göster',
        saved: 'Düzeniniz kaydedildi.',
        settingsSaved: '{{name}} kaydedildi.',
        deleted: '{{name}} silindi.',
      },
      profile: {
        welcomeNewUser: 'Hoş geldiniz! Lütfen profilinizi tamamlayın',
        newUserMessage: 'Aşağıdaki bilgilerinizi doldurarak deneyiminizi kişiselleştirmemize yardımcı olun.',
        continueToDashboard: 'Panele Devam Et',
        myProfile: 'Profilim',
        reviewDetails: 'Kişisel bilgilerinizi gözden geçirin ve güncelleyin',
        completeProfile: 'Profilinizi tamamlayın',
        keepUpdated: 'Daha iyi kişiselleştirilmiş içgörüler için bilgilerinizi güncel tutun',
        accountInformation: 'Hesap Bilgileri',
        referenceCode: 'Referans Kodu',
        anonymousSharingId: 'Anonim paylaşım kimliğiniz',
        activeSince: 'Aktif olduğu tarih',
        personalDetails: 'Kişisel Bilgiler',
        firstName: 'Ad',
        lastName: 'Soyad',
        nickname: 'Takma Ad',
        nicknamePlaceholder: 'Size nasıl hitap edilmesini istersiniz?',
        birthDate: 'Doğum tarihi',
        gender: 'Cinsiyet',
        genderMale: 'Erkek',
        genderFemale: 'Kadın',
        genderPrefernottosay: 'Belirtmek istemiyorum',
        emailAddress: 'E-posta Adresi',
        emailPlaceholder: 'sizin.email@ornek.com',
        emailHelper: 'Güncellemeler ve bildirimler için e-posta adresi',
        aboutMe: 'Hakkımda',
        headline: 'Başlık',
        headlinePlaceholder: 'Kendiniz hakkında kısa bir slogan',
        bio: 'Biyografi',
        bioPlaceholder: 'Bize kendiniz hakkında biraz bilgi verin',
        motivation: 'Motivasyon',
        motivationPlaceholder: 'Bu platformu kullanmanızda sizi ne motive ediyor?',
        privacyDataSharing: 'Gizlilik ve Veri Paylaşımı',
        sharingPreference: 'Paylaşım Tercihi',
        sharingHelper: 'Bu platformda verilerinizi nasıl paylaşmak istediğinizi seçin',
        shareAnonymously: 'Verilerimi anonim olarak paylaş',
        shareWithName: 'Verilerimi adımla birlikte paylaş',
        doNotShare: 'Verilerimi paylaşma',
        notificationPreferences: 'Bildirim Tercihleri',
        pushNotifications: 'Push bildirimleri',
        pushNotificationsDesc: 'Cihazınızda push bildirimleri alın',
        emailNotifications: 'E-posta bildirimleri',
        emailNotificationsDesc: 'E-posta ile bildirimler alın',
        inAppNotifications: 'Uygulama içi bildirimler',
        inAppNotificationsDesc: 'Uygulama içinde bildirimler alın',
        programmeNotifications: 'Program Bildirimleri',
        programmeNotificationsHelper: 'Her program için, planlanan bir ölçümden kaç dakika önce hatırlatılmak istediğinizi seçin. Bir programın hatırlatmalarını tamamen durdurmak için o programın bildirimlerini kapatın.',
        reminderTime: 'Hatırlatma zamanı',
        reminderTimeCustomLabel: 'Dakika (1-180)',
        reminderNoScheduledMeasurements: 'Bu programda henüz planlanmış ölçüm yok.',
        notificationsLabel: 'Bildirimler',
        reminderLoadFailed: 'Hatırlatma ayarları yüklenemedi',
        saving: 'Kaydediliyor...',
        saveProfile: 'Profili Kaydet',
        saveSuccess: 'Profil başarıyla kaydedildi',
        errorLoading: 'Profil yüklenemedi',
        errorSaving: 'Profil kaydedilemedi',
      },
      uploadPDF: {
        title: 'Belge Yükle',
        description: 'PDF dosyalarınızı burada yükleyebilirsiniz.',
        documentType: 'Belge türü',
        selectDocumentType: 'Belge türü seçin',
        labTest: 'Laboratuvar testi',
        insuranceDocument: 'Sigorta belgesi',
        idCard: 'Kimlik kartı',
        enabledAIExtraction: 'Etkin: Yüklemeden sonra gözlemleri çıkaracağız.',
        disabledAIExtraction: 'Devre dışı: Sadece belgeyi depolayacağız.',
        descriptionTitle: 'Açıklama',
        descriptionLabel: 'Açıklama',
        descriptionPlaceholder: 'örn. Doktor ziyaretinden kan testi (24/01/2026)',
        filenameTitle: 'Dosya adı',
        filenameLabel: 'Dosya adı',
        filenamePlaceholder: 'Bir dosya adı girin',
        filenameRequired: 'Lütfen bir dosya adı girin.',
        aiExtractionTitle: 'Yapay Zekâ Çıkarımı',
        aiExtractionSelectTypeHelper: 'Yapay zekâ çıkarım seçeneklerini görmek için bir belge türü seçin.',
        dropFilesPrompt: 'Dosyaları buraya bırakın veya cihazınızdan seçin',
        chooseFiles: 'Dosya(lar) Seç',
        deleteDocument: 'Seçimi temizle',
        filesSelected: 'dosya seçildi',
        uploadButton: 'Yükle',
        documentSuccessfullyUploaded: 'Belge başarıyla yüklendi.',
        aiExtractionNotAvailable: 'Yapay zeka cikarimi bu belge turu icin kullanilamiyor',
      },
      savedDocuments: {
        fileName: 'Dosya Adı',
        fileType: 'Dosya Türü',
        uploadedBy: 'Yukleyen',
        description: 'Açıklama',
        uploadDate: 'Yükleme Tarihi',
        status: 'Durum',
        inProgress: 'Devam Ediyor',
        readyForReview: 'İncelemeye Hazır',
        committed: 'Taahhüt Edildi',
        inReview: 'İncelemede',
        uploaded: 'Yüklendi',
        failed: 'Basarisiz',
        unknownStatus: 'Basarisiz',
        noStatus: 'Durum yok',
        noDocuments: 'Belge bulunamadı',
        yourDocuments: 'Belgeleriniz',
        viewPreviouslyUploaded: 'Daha önce yüklenen belgeleri görüntüle',
        documents: 'Belgeler',
        filter: 'Filtrele',
        allTypes: 'Tümü',
        preview: 'Önizleme',
        uploadNewDocument: 'Yeni bir belge yükle',
        review: 'Gozden',
        delete: 'Sil',
        updateDocument: 'Belgeyi güncelle',
        update: 'Guncelle',
        cancel: 'İptal',
        save: 'Kaydet',
        documentSuccessfullyDeleted: 'Belge başarıyla silindi',
        deleteError: 'Belge silinirken hata oluştu',
        deleteErrorPartial_one: '{{count}} belge silinemedi',
        deleteErrorPartial_other: '{{count}} belge silinemedi',
        downloadError: 'Belge indirilemedi',
        deleteConfirm: '{{count}} belgeyi silmek istediğinizden emin misiniz?',
        deleting: 'Siliniyor...',
        close: 'Kapat',
        download: 'İndir',
        types: {
          bloodTestReport: 'Kan Testi Raporu',
          stoolTestReport: 'Dışkı Testi Raporu',
          consultationNote: 'Konsültasyon Notu',
        },
        updateSuccess: 'Belge güncellendi',
        updateError: 'Belge güncellenemedi',
      },
      documentExtractionReview: {
        aiChip: 'TRPI Yapay Zeka Destekli',
        title: 'Çıkarma İncelemesi',
        previewTitle: 'Belge Önizleme',
        preview: {
          loadingDocument: 'Belge yükleniyor...',
          preparingPdf: 'PDF hazırlanıyor...',
          zoom: 'Yakınlaştırma {{percent}}%',
          zoomControlsAria: 'Yakınlaştırma kontrolleri',
          zoomOut: 'Küçült',
          fit: 'Sığdır',
          zoomIn: 'Yakınlaştır',
          fullscreen: 'Tam ekran',
          exitFullscreen: 'Tam ekrandan çık',
          unavailable: 'Bu dosya için uygulama içi önizleme kullanılamıyor. Görüntülemek için bu dosyayı indirin.',
          pageOf: 'Sayfa {{current}} / {{total}}',
          prevPageAria: 'Önceki sayfa',
          nextPageAria: 'Sonraki sayfa',
        },
        subtitle: 'Çıkarılan değerleri temel gözlemlerinize kaydetmeden önce inceleyin.',
        committedInfo: 'Bu belge artık düzenlenemez, ancak çıkarılan değerleri inceleyebilirsiniz.',
        commit: {
          action: 'Çekirdeğe Kaydet',
          committed: 'Kaydedildi',
          aria: 'Çıkarılan ölçümleri kaydet',
          success: 'Belge kaydedildi',
          error: 'Belge kaydedilemedi',
        },
        tooltips: {
          download: 'İndir',
          fullscreen: 'Tam ekran',
          exitFullscreen: 'Tam ekrandan çık',
        },
        aria: {
          download: 'Belgeyi indir',
          fullscreen: 'Sağ panel tam ekranını değiştir',
        },
        updatedAt: 'Güncellendi: {{date}}',
        failedMessage: 'Çıkarma başarısız oldu. Belgeyi yine de önizleyebilirsiniz. Sorun devam ederse destekle iletişime geçin.',
        loadDataError: 'Çıkarılan veriler yüklenirken hata oluştu. Lütfen tekrar deneyin.',
        extractionInProgress: 'Çıkarma devam ediyor.',
        notExtracted: 'Çıkarılmadı',
        timeline: {
          button: 'Zaman çizelgesini gör',
          title: 'Çıkarma zaman çizelgesi',
        },
        loading: 'Çıkarma yükleniyor...',
        providers: {
          organisation: 'organizasyon',
          practitioner: 'hekim',
          searchPlaceholder: 'Mevcut {{type}} ara',
          notInList: 'Listede yok',
        },
        sections: {
          measurements: {
            title: 'Çıkarılan Ölçümler',
            columns: {
              measurementName: 'Çıkarılan Ölçüm',
              valueExtracted: 'Çıkarılan Değer',
              unitExtracted: 'Birim (çıkarılan)',
              ucumCode: 'UCUM Kodu',
              ucumName: 'UCUM Adı',
              loincCode: 'LOINC Kodu',
              loincName: 'LOINC Adı',
              referenceRangeMin: 'Ref min',
              referenceRangeMax: 'Ref max',
            },
            actions: {
              resetColumns: 'Sütun görünürlüğünü sıfırla',
              edit: 'Ölçümleri düzenle',
              save: 'Ölçümleri kaydet',
              cancel: 'Ölçüm değişikliklerini iptal et',
              deleteRow: 'Satırı sil',
              deleteRowDisabled: 'Satır silmek için düzenleme modunu etkinleştir',
              addRow: 'Satır ekle',
            },
            aria: {
              resetColumns: 'Sütun görünürlüğünü sıfırla',
              edit: 'Çıkarılan ölçümleri düzenle',
              save: 'Çıkarılan ölçümleri kaydet',
              cancel: 'Çıkarılan ölçüm değişikliklerini iptal et',
              deleteRow: 'Satır {{id}} sil',
            },
            toasts: {
              addSuccess: 'Ölçüm satırı eklendi',
              addError: 'Ölçüm satırı eklenemedi',
              deleteSuccess: 'Ölçüm silindi',
              deleteError: 'Ölçüm silinemedi',
            },
          },
          organisation: {
            title: 'Uygulayan Organizasyon',
            status: {
              matchFound: 'Organizasyon bulundu',
              noMatch: 'Organizasyon bulunamadı',
            },
            tooltips: {
              validation: 'Lütfen doğru değerleri girin',
              save: 'Organizasyon bilgilerini kaydet',
              cancel: 'Organizasyon değişikliklerini iptal et',
            },
            aria: {
              edit: 'Uygulayan organizasyonu düzenle',
              save: 'Uygulayan organizasyon değişikliklerini kaydet',
              cancel: 'Çıkarılan organizasyon değişikliklerini iptal et',
            },
            fields: {
              name: 'Ad',
              address: 'Adres',
              houseNumber: 'Bina No',
              city: 'Sehir',
              postalCode: 'Posta Kodu',
              countryCode: 'Ulke Kodu',
              contactPerson: 'Yetkili Kisi',
              phoneNumber: 'Telefon Numarasi',
              emailAddress: 'E-posta',
            },
          },
          practitioner: {
            title: 'Talep Eden Hekim',
            status: {
              matchFound: 'Hekim bulundu',
              noMatch: 'Hekim bulunamadı',
            },
            tooltips: {
              validation: 'Lütfen doğru değerleri girin',
              save: 'Hekim bilgilerini kaydet',
              cancel: 'Hekim değişikliklerini iptal et',
            },
            aria: {
              edit: 'Talep eden hekimi düzenle',
              save: 'Talep eden hekim değişikliklerini kaydet',
              cancel: 'Çıkarılan hekim değişikliklerini iptal et',
            },
            fields: {
              name: 'Ad',
              role: 'Rol',
              phoneNumber: 'Telefon Numarasi',
              emailAddress: 'E-posta',
            },
          },
        },
        sectionSaved: 'Değişiklikleriniz kaydedildi.',
        sectionSaveFailed: 'Değişiklikleriniz kaydedilemedi.',
      },
      content: {
        billing: {
          title: 'Faturalama ve Ödemeler',
          description: 'Gelişmiş işlevsellik için abonelikleri, ödemeleri ve premium özellikleri yönetin.',
          viewBilling: 'Faturalamayı Görüntüle',
        },
      },
      masterData: {
        tabs: {
          measurements: 'Ölçümler',
          units: 'Birimler',
        },
        measurementList: {
          subtitle: 'Platformun bildiği tüm kodlar: LOINC sürümü ve platformun kendi kodları. Eksenlerini ve birimlerini görmek için birini aç.',
        },
        measurementCodes: {
          list: {
            columns: {
              name: 'Ad',
              code: 'Kod',
              codeSystem: 'Kod sistemi',
              status: 'Durum',
              inUse: 'Kullanımda',
            },
            yes: 'Evet',
            no: 'Hayır',
            views: {
              label: 'Göster',
              all: 'Tüm kodlar',
              inUse: 'Kullanımda',
            },
            systemFilter: 'Kod sistemi',
            systemAll: 'Tüm kod sistemleri',
          },
          general: {
            code: 'Kod',
            codeSystem: 'Kod sistemi',
            name: 'Ad',
            status: 'Durum',
            release: 'Sürüm',
            releaseValue: '{{version}}, {{date}} tarihinde yüklendi',
            releaseNone: 'Geçerli değil: platform kodlarının sürümü yoktur.',
            releaseUnknown: 'Bu kod için kaydedilmedi.',
            valueKind: 'Değer türü',
            quantityKind: 'Nicelik türü',
          },
          axes: {
            title: 'Neyi ölçer',
            component: 'Bileşen',
            analyte: 'Analit',
            property: 'Özellik',
            time: 'Zaman',
            system: 'Sistem',
            scale: 'Ölçek',
            method: 'Yöntem',
            noMethod: 'Yok',
            unknown: 'Platform bu kodun eksenlerini bilmiyor. Hiçbir şeyle gruplanmaz.',
          },
          groups: {
            title: 'Şunlarla gruplanır',
            nothing: 'Bu düzeyde hiçbir şeyle gruplanmaz.',
          },
          levels: {
            THIS_CODE: 'Yalnızca bu kod',
            ANY_METHOD: 'Aynı şey, yöntem fark etmez',
          },
          trace: {
            title: 'Bir değerin izini sür',
            help: 'Bir değer için sana verilen numarayı gir. Nasıl kaydedildiğini ve nereden geldiğini görürsün.',
            number: 'Değer numarası',
            show: 'Kaynağı göster',
          },
          dialog: {
            addTitle: 'Platform ölçümü ekle',
            editTitle: '{{name}} düzenle',
            name: 'Ad',
            code: 'Kod',
            codeHelp: 'X ile başlar, örneğin X-HAPPY-1. İki ölçüm aynı kodu paylaşamaz.',
            codeSystem: 'Kod sistemi',
            analyteHelp: 'Bileşeni kullanmak için boş bırak.',
            noPart: 'Eşleşen Part yok. Eklemek için bir ad yaz.',
            partsFailed: 'Part\'lar okunamadı. Yeniden denemek için tekrar yaz.',
            addPart: '"{{name}}" öğesini yeni Part olarak ekle',
            partAdded: '{{name}} Part olarak eklendi',
            newPropertyKind: 'Yeni özellik için nicelik türü',
            newPropertyKindHelp: 'Yalnızca yukarıda yeni bir özellik eklersen kullanılır.',
            noKind: 'Yok',
          },
        },
        dimensionWords: {
          length: 'uzunluk',
          mass: 'kütle',
          time: 'zaman',
          amountOfSubstance: 'madde miktarı',
          electricCurrent: 'elektrik akımı',
          temperature: 'sıcaklık',
          luminousIntensity: 'ışık şiddeti',
          dimensionless: 'boyutsuz',
          per: 'başına',
        },
        unitTabs: {
          label: 'Birimler ve mol kütleleri',
          units: 'Birim listesi',
          molarMasses: 'Mol kütleleri',
        },
        unitList: {
          subtitle: 'Değerlerin her kuruluş için kaydedilebileceği birimler ve boyutları. Hangi ölçümün hangisini kullandığı her ölçümde belirlenir.',
          noUcum: 'UCUM kodu yok',
          noDimension: 'Boyut yok',
          columns: {
            quantityKinds: 'Nicelikler',
          },
        },
        unitDialog: {
          dimensionHelp: 'UCUM kodu olmayan bir birimin boyutunu buraya girersin. Aynı boyuttaki birimler birbirine dönüştürülebilir.',
          noDimension: 'Boyut yok',
          ucumHelp: 'Platformdaki UCUM sürümünden bir kod, örneğin kg. İki birim aynı kodu paylaşamaz.',
          noUcum: 'Bu birimin UCUM kodu yok. Varsa bir tane ekle, örneğin kg.',
          workedOut: 'UCUM kodundan hesaplandı.',
          workedOutAfterSave: 'Kaydettiğinde hesaplanır.',
          quantityKinds: 'İfade edebileceği nicelikler',
          quantityKindsHelp: 'Bir birim, ölçümün belirttiği niceliği ifade edebiliyorsa o ölçüme uyar. QUDT\'den alınır veya burada seçilir.',
          dimensionsFailed: 'Boyutlar okunamadı, bu yüzden hiçbiri seçilemez.',
          dimensionsRetry: 'Tekrar dene',
        },
        measurementUnits: {
          add: 'Birim bağla',
          edit: 'Bağlantıyı düzenle',
          remove: 'Bağlantıyı kaldır',
          isDefault: 'Kanonik',
          columns: {
            isDefault: 'Kanonik',
            conversion: 'Kanonik birime dönüşüm',
            approvedBy: 'Onaylayan',
            validMinimum: 'Şundan itibaren geçerli',
            validMaximum: 'Şuna kadar geçerli',
          },
          confirm: 'Faktörü onayla',
          confirmedToast: '{{unit}} faktörü onaylandı',
          factor: '1 {{from}} = {{multiplier}} {{to}}',
          factorWithOffset: '({{from}} + {{offset}}) × {{multiplier}} = {{to}}',
          viaAlgebra: 'UCUM kodlarından hesaplandı.',
          viaMolarMass: '{{analyte}} mol kütlesi üzerinden, {{mass}} g/mol. Kaynak: {{source}}.',
          formula: '{{factor}}. {{via}}',
          approved: '{{by}}, {{date}}',
          notApproved: 'Henüz onaylanmadı',
          unavailable: {
            dimensionDiffers: 'Faktör yok: Bu birimin boyutu kanonik birimden farklı.',
            noCanonicalUnit: 'Henüz faktör yok: Ölçümün kanonik birimi yok.',
            noMolarMass: 'Henüz faktör yok: Analitin mol kütlesi kayıtlı değil.',
            noDimension: 'Faktör yok: Bu birimin boyutu yok.',
          },
          enterMolarMass: 'Mol kütlesini gir',
          removeDialog: {
            title: 'Bu bağlantı kaldırılsın mı?',
          },
        },
        unitLinkDialog: {
          isDefault: 'Kanonik birim: Değerler bu birimle gösterilir ve aralığı kontrol edilir',
          isDefaultHelp: 'Bir ölçümün ilk birimi onun kanonik birimidir. Yalnızca bir tane vardır.',
          otherDefault: 'Kanonik olan başka bir birim. Önce orada kapat.',
          validMinimum: 'Geçerli en düşük değer',
          validMaximum: 'Geçerli en yüksek değer',
          validHelp: 'İsteğe bağlı. Kaydedilebilecek en düşük değer, {{unit}} cinsinden. Başka birimdeki değer önce dönüştürülür.',
          rangeWrong: 'En düşük değer en yüksek değerden büyük.',
        },
        molarMasses: {
          title: 'Mol kütleleri',
          subtitle: 'Kütle konsantrasyonu, aynı analitin molar konsantrasyonuyla mol kütlesi üzerinden buluşur. Her kütlenin bir kaynağı vardır.',
          add: 'Mol kütlesi ekle',
          edit: 'Mol kütlesini düzenle',
          remove: 'Mol kütlesini kaldır',
          addTitle: 'Mol kütlesi ekle',
          editTitle: '{{name}} mol kütlesini düzenle',
          columns: {
            analyte: 'Analit',
            gramsPerMole: 'Mol başına gram',
            source: 'Kaynak',
          },
          analyte: 'Analit',
          analyteHelp: 'Ad veya Part numarasıyla ara, örneğin Glukoz.',
          gramsPerMole: 'Mol başına gram',
          massHelp: 'Glukoz için: 180.156.',
          massWrong: '0\'dan büyük bir sayı gir; noktadan önce ve sonra en fazla on basamak olabilir.',
          source: 'Kaynak',
          sourceHelp: 'Sayının nereden geldiği: bir LOINC grubu, bir ChEBI veya PubChem tanımlayıcısı, bir başvuru kaynağı.',
          removeDialog: {
            title: 'Bu mol kütlesi kaldırılsın mı?',
            message: '{{name}} artık mol kütlesine sahip değil. Onu kullanan faktörler artık hesaplanamaz.',
          },
        },
      },
      tenantSettings: {
        title: 'Tenant Ayarları',
        subtitle: 'Ayarları yönet',
        loadError: 'Tenant ayarları yüklenemedi. Bu tenant\'ı görüntüleme izniniz olmayabilir.',
        generalInfo: 'Genel Bilgiler',
        tenantName: 'Tenant Adı',
        organisation: 'Organizasyon',
        organisationHelper: 'Organizasyon değiştirilemez',
        tenantId: 'Tenant ID',
        yourRole: 'Rolünüz',
        roleDescription: 'Bu organizasyondaki rolünüz {{role}}.',
        permissionsConfigured: 'Bu rolün ne yapabileceğini organizasyonun kendisi yapılandırır. Bir yönetici bunu roller ekranında görüp değiştirebilir.',
        saveName: 'Adı kaydet',
        nameSaved: 'Kiracı adı güncellendi.',
        saveError: 'Ad kaydedilemedi. Bunu değiştirme izniniz olmayabilir.',
      },
      communityUsers: {
        title: 'Topluluk Kullanıcıları',
        subtitle: 'Platformda hesabı olan tüm kullanıcılar. Kişisel bilgiler yalnızca her kullanıcının gizlilik tercihlerine göre gösterilir.',
        loadError: 'Topluluk kullanıcıları yüklenemedi. Lütfen tekrar deneyin.',
        view: 'Görüntüle',
        noUsersTitle: 'Paylaşılan kullanıcı yok',
        noUsersNotice: 'Henüz kimse verilerini görüntülemeye açmadı.',
      },
      adminDashboard: {
        menuItems: {
          questionnaires: 'Anketler',
          tenants: 'Kiracılar',
          organisations: 'Organizasyonlar',
          users: 'Sistem kullanıcıları',
        },
        users: {
          title: 'Sistem kullanıcıları',
          comingSoon: 'Kullanıcı yönetimi yakında geliyor...',
        },
      },
      organisationDialog: {
        titleCreate: 'Yeni Organizasyon Oluştur',
        titleEdit: 'Organizasyonu düzenle',
        emailInvalid: 'ad@ornek.com gibi bir e-posta adresi girin',
        dateInvalid: 'Bir tarih girin',
        legalNameRequired: 'Yasal ad gereklidir',
        createError: 'Organizasyon oluşturulamadı. Benzersiz alanların zaten kullanımda olup olmadığını kontrol edin.',
        fields: {
          legalName: 'Yasal Ad',
          tradeName: 'Ticari Ad',
          taxId: 'Vergi Kimlik Numarası',
          referenceCode: 'Referans Kodu',
          emailAddress: 'E-posta Adresi',
          phoneNumber: 'Telefon Numarası',
          website: 'Web Sitesi',
          practiceCode: 'Uygulama Kodu',
          chamberOfCommerceNumber: 'Ticaret Odası Numarası',
          subscriptionDate: 'Abonelik Tarihi',
          active: 'Aktif',
        },
        actions: {
          create: 'Oluştur',
        },
      },
      organisationList: {
        title: 'Organizasyonlar',
        addButton: 'Organizasyon ekle',
        updateSuccess: 'Organizasyon başarıyla güncellendi',
        updateError: 'Organizasyon güncellenemedi',
        columns: {
          legalName: 'Yasal adı',
          tradeName: 'Ticari adı',
          taxId: 'Vergi numarası',
          referenceCode: 'Referans kodu',
          emailAddress: 'E-posta',
          phoneNumber: 'Telefon',
          website: 'Web sitesi',
          practiceCode: 'Uygulama kodu',
          chamberOfCommerceNumber: 'Ticaret odası numarası',
          subscriptionDate: 'Abonelik tarihi',
          status: 'Durum',
        },
        statusLabels: {
          active: 'Aktif',
          inactive: 'Pasif',
        },
        edit: 'Düzenle',
        deactivate: 'Devre dışı bırak',
        alreadyInactive: 'Zaten devre dışı. Düzenle ile yeniden etkinleştirin.',
        deactivateTitle: 'Organizasyonu devre dışı bırak',
        deactivateMessage: '{{name}} devre dışı olarak işaretlenecek. Hiçbir şey silinmez ve Düzenle ile yeniden etkinleştirebilirsiniz.',
        deactivated: 'Organizasyon devre dışı bırakıldı',
        created: 'Organizasyon oluşturuldu',
      },
      questionnaireEditor: {
        questionsCount: 'Sorular ({{count}})',
        addQuestionButton: 'Soru ekle',
        emptyState: {
          message: 'Henüz soru yok. İlk sorunuzu ekleyin!',
          button: 'Soru ekle',
        },
        question: {
          prefix: 'Soru',
          required: 'Zorunlu',
          identity: 'Kimlik: ',
          optionsLabel: 'Seçenekler:',
        },
        tooltips: {
          edit: 'Düzenle',
          delete: 'Sil',
        },
        dialog: {
          titleNew: 'Yeni soru',
          titleEdit: 'Soruyu düzenle',
          questionType: 'Soru türü',
          questionPrompt: 'Soru metni',
          requiredQuestion: 'Zorunlu soru',
          identityField: 'Bu bir kimlik alanıdır (kullanıcı katılımı için)',
          identityFieldType: 'Kimlik alan türü',
          listOptionsTitle: 'Liste seçenekleri',
          addOptionButton: 'Seçenek ekle',
          codeLabel: 'Kod',
          codePlaceholder: 'örn., MEM_YUKSEK',
          valueLabel: 'Görüntüleme değeri',
          valuePlaceholder: 'örn., Çok memnun',
          emptyOptions: 'Açılır menü soruları için en az bir seçenek ekleyin',
          cancel: 'İptal',
          save: 'Kaydet',
          create: 'Oluştur',
          removeOption: 'Seçeneği kaldır',
        },
        deleteDialog: {
          title: 'Soruyu sil',
          message: 'Bu soruyu silmek istediğinizden emin misiniz? Bu, ilişkili tüm cevapları da silecektir.',
          cancel: 'İptal',
          delete: 'Sil',
        },
        messages: {
          updateSuccess: 'Soru başarıyla güncellendi',
          createSuccess: 'Soru başarıyla oluşturuldu',
          deleteSuccess: 'Soru başarıyla silindi',
          saveError: 'Soru kaydedilemedi',
          deleteError: 'Soru silinemedi',
        },
        questionTypes: {
          text: 'Metin',
          number: 'Sayı',
          date: 'Tarih',
          list: 'Liste/Açılır menü',
          boolean: 'Evet/Hayır',
        },
        identityTypes: {
          first_name: 'Ad',
          last_name: 'Soyad',
          email: 'E-posta',
          date_of_birth: 'Doğum tarihi',
        },
      },
      questionnaireList: {
        title: 'Anketler',
        newButton: 'Anket ekle',
        table: {
          name: 'Ad',
          description: 'Açıklama',
          status: 'Durum',
          version: 'Sürüm',
          publicLink: 'Genel bağlantı',
        },
        statusLabels: {
          active: 'Aktif',
          inactive: 'Pasif',
        },
        dialog: {
          titleNew: 'Anket ekle',
          titleEdit: 'Anketi düzenle',
          name: 'Ad',
          description: 'Açıklama',
          active: 'Aktif',
          create: 'Oluştur',
          nameRequired: 'Bir ad girin',
          publicLink: 'Herkese açık bağlantı',
          noPublicLink: 'Bu anketin henüz herkese açık bir bağlantısı yok.',
          newLink: 'Kaydederken yeni bir bağlantı oluştur. Mevcut bağlantı artık çalışmaz.',
          makeLink: 'Kaydederken herkese açık bir bağlantı oluştur',
        },
        deleteDialog: {
          title: 'Anketi kaldır',
          message: '{{name}} ve soruları kaldırılacak. Kişilerin yanıtladığı bir anket kaldırılmaz; bunun yerine devre dışı bırakın.',
          delete: 'Kaldır',
        },
        messages: {
          updateSuccess: 'Anket başarıyla güncellendi',
          createSuccess: 'Anket başarıyla oluşturuldu',
          deleteSuccess: 'Anket kaldırıldı',
          saveError: 'Anket kaydedilemedi',
          linkCopied: 'Bağlantı panoya kopyalandı',
          copyFailed: 'Bağlantı kopyalanamadı',
        },
        copyLink: 'Bağlantıyı kopyala',
        copyLinkOf: '{{name}} anketinin herkese açık bağlantısını kopyala',
        noLink: 'Yok',
        edit: 'Düzenle',
        delete: 'Kaldır',
        noOrganisationTitle: 'Henüz organizasyon yok',
        noOrganisationNotice: 'Anketler bir organizasyona aittir ve bu hesap hiçbirine ait değil.',
      },
      submissionViewer: {
        table: {
          id: 'ID',
          status: 'Durum',
          email: 'E-posta',
          name: 'Ad',
          submittedAt: 'Gönderilme tarihi',
        },
        statusLabels: {
          submitted: 'Gönderildi',
          draft: 'Taslak',
          scored: 'Puanlandı',
          abandoned: 'Terk edildi',
        },
        dialog: {
          title: 'Gönderi - Cevaplar',
          submissionDetails: 'Gönderi detayları',
          status: 'Durum',
          submittedAt: 'Gönderilme tarihi',
          notYetSubmitted: 'Henüz gönderilmedi',
          email: 'E-posta',
          name: 'Ad',
          answersCount: 'Cevaplar ({{count}})',
          noAnswers: 'Henüz cevap gönderilmedi.',
          questionPrefix: 'Soru {{number}}',
          close: 'Kapat',
          unknownQuestion: 'Artık bu ankette olmayan bir soru',
        },
        booleanValues: {
          yes: 'Evet',
          no: 'Hayır',
        },
        answersFailed: 'Yanıtlar yüklenemedi',
        openAnswers: '{{sent}} tarihinde gönderilen yanıtlar',
      },
      tenantList: {
        title: 'Kiracılar',
        addButton: 'Kiracı Ekle',
        saveError: 'Kiracı kaydedilemedi',
        noOrganisationsWarning: 'Kullanılabilir organizasyon yok. Kiracı eklemeden önce bir organizasyon oluşturun.',
        table: {
          id: 'ID',
          name: 'İsim',
          organisation: 'Organizasyon',
        },
        tooltips: {
          edit: 'Düzenle',
        },
        dialog: {
          titleCreate: 'Kiracı Oluştur',
          titleEdit: 'Kiracıyı Düzenle',
          tenantName: 'Kiracı Adı',
          organisation: 'Organizasyon',
          create: 'Oluştur',
          nameRequired: 'Bir ad girin',
          organisationRequired: 'Bir kuruluş seçin',
          organisationLocked: 'Bir kiracı kendi kuruluşunda kalır',
        },
        messages: {
          created: 'Kiracı eklendi',
          updated: 'Kiracı kaydedildi',
        },
      },
      publicQuestionnairePage: {
        loading: 'Yükleniyor...',
        invalidLink: 'Geçersiz anket bağlantısı',
        notFound: 'Anket bulunamadı veya artık etkin değil',
        checkLink: 'Lütfen bağlantıyı kontrol edin ve tekrar deneyin.',
        thankYou: 'Teşekkürler!',
        submitted: 'Yanıtlarınız başarıyla gönderildi.',
        newAccountCreated: 'Sizin için yeni bir hesap oluşturuldu. Giriş talimatları için e-postanızı kontrol edin.',
        progress: 'İlerleme',
        questions: 'sorular',
        required: 'Bu alan zorunludur',
        identityFieldInfo: 'Bu bilgiler hesabınızı oluşturmak için kullanılacaktır',
        submitButton: 'Anketi Gönder',
        submitting: 'Gönderiliyor...',
        autoSave: 'Yanıtlarınız yazdıkça otomatik olarak kaydedilir',
        missingRequired: 'Lütfen tüm zorunlu soruları cevaplayın ({{count}} kaldı)',
        submitError: 'Anket gönderilemedi. Lütfen tekrar deneyin.',
        placeholders: {
          text: 'Cevabınızı girin...',
          number: 'Bir sayı girin...',
          email: 'E-postanızı girin',
          firstName: 'Adınızı girin',
          lastName: 'Soyadınızı girin',
          dateOfBirth: 'Doğum tarihinizi girin',
        },
        booleanValues: {
          yes: 'Evet',
          no: 'Hayır',
        },
        answerSaveFailed: 'Yanıtınız kaydedilemedi. Lütfen tekrar deneyin.',
      },
      manageProgrammeMeasurements: {
        title: 'Program Ölçümleri',
        tenant: 'Kiracı',
        addButton: 'Program Ölçümü Ekle',
        noProgrammes: 'Kullanılabilir program yok. Lütfen önce bir program oluşturun.',
        noOrganisationTitle:
          'Henüz kuruluş yok',
        noOrganisation: 'Program ölçümleri bir kuruluşa aittir ve bu hesap hiçbir kuruluşa ait değil.',
        rolesUnknownTitle: 'Rolleriniz okunamadı',
        rolesUnknownNotice:
          'Onlar olmadan bu ekran hangi kuruluşu göreceğini bilemez; bu, hiçbir kuruluşa ait olmamakla aynı değil.',
        table: {
          programmeName: 'Program Adı',
          measurementName: 'Ölçüm Adı',
          loincCode: 'LOINC kodu',
          minimumTarget: 'Minimum Hedef',
          maximumTarget: 'Maksimum Hedef',
          defaultUnit: 'Varsayılan Birim',
          reminder: 'Hatırlatma',
          everyWeeks: 'Her {{count}} haftada bir: {{days}}',
        },
        actions: {
          edit: 'Düzenle',
          delete: 'Sil',
        },
        dialog: {
          titleAdd: 'Program Ölçümü Ekle',
          titleEdit: 'Program Ölçümünü Düzenle',
          programme: 'Program',
          measurement: 'Ölçüm',
          minimumTarget: 'Minimum Hedef',
          maximumTarget: 'Maksimum Hedef',
          defaultUnit: 'Varsayılan Birim',
          selectProgramme: 'Bir program seçin',
          selectMeasurement: 'Bir ölçüm seçin',
          measurementSearchHint: 'Adın veya kodun en az üç harfini yaz.',
          measurementNoMatch: 'Eşleşen ölçüm yok.',
          measurementSearchFailed: 'Ölçümler okunamadı. Yeniden denemek için tekrar yaz.',
          selectUnit: 'Bir birim seçin',
          repeatEvery: 'Her',
          weeks: 'hafta',
          repeatOn: 'Şu günlerde yinele',
          ends: 'Bitiş',
          endsProgrammeEnd: 'Program bittiğinde',
          endsOn: 'Tarihte',
          endsAfter: 'Şu kadar sonra',
          occurrences: 'yineleme',
          timeOfDay: 'Saatte',
          timeOfDayOptional: 'isteğe bağlı',
          selectWeekdaysFirstWarning: 'Önce bir gün seçin',
          recurrenceHint: 'Hiçbir gün seçmezseniz hiçbir zamanlama kaydedilmez. Haftalar, programın başladığı haftadan itibaren sayılır.',
          programmeHasNoEndDate: 'Bu programın bitiş tarihi yok, bu nedenle süresiz olarak yinelenir',
          save: 'Kaydet',
          update: 'Güncelle',
        },
        deleteConfirm: '"{{measurementName}}" ölçümünü "{{programmeName}}" programından silmek istediğinizden emin misiniz?',
        deleteTitle: 'Bu ölçüm programdan kaldırılsın mı?',
        messages: {
          loadRolesFailed: 'Kiracı rolleri yüklenemedi',
          loadDataFailed: 'Veriler yüklenemedi',
          partlyRead: 'Bazı programların ölçümleri okunamadı, bu yüzden bu liste eksik olabilir.',
          noTenantSelected: 'Hiçbir kiracı seçilmedi',
          selectProgrammeError: 'Lütfen bir program seçin',
          selectMeasurementError: 'Lütfen bir ölçüm seçin',
          selectUnitError: 'Lütfen bir varsayılan birim seçin',
          recurrenceIntervalError: 'Yineleme aralığı 1 ile 52 arasında tam sayı bir hafta olmalıdır',
          recurrenceEndDateError: 'Programın başlangıcından önce olmayan bir bitiş tarihi seçin',
          recurrenceOccurrencesError: 'Yineleme sayısı 1 ile 520 arasında bir tam sayı olmalıdır',
          deleteSuccess: 'Program ölçümü başarıyla silindi',
          addSuccess: 'Program ölçümü başarıyla eklendi',
          addFailed: 'Program ölçümü eklenemedi',
          updateSuccess: 'Program ölçümü başarıyla güncellendi',
          updateFailed: 'Program ölçümü güncellenemedi',
          notAllowed: 'Bunu değiştiremezsin.',
        },
      },
      manageProgrammeDialog: {
        titleCreate: 'Yeni Program Oluştur',
        titleEdit: 'Programı Düzenle',
        programmeName: 'Program Adı',
        programmeNameRequired: 'Program adı gereklidir',
        description: 'Açıklama',
        targetAudience: 'Hedef Kitle',
        startDate: 'Başlangıç Tarihi',
        startDateRequired: 'Başlangıç tarihi gereklidir',
        startDateLocked:
          'Başlangıç tarihi oluşturulduktan sonra değiştirilemez',
        endDate: 'Bitiş Tarihi',
        endDateHelper: 'Devam eden programlar için boş bırakın',
        endDateError: 'Bitiş tarihi başlangıç tarihinden sonra olmalıdır',
        startDatePast: 'Başlangıç tarihi geçmişte olamaz',
        endDatePast: 'Bitiş tarihi geçmişte olamaz',
        saveChanges: 'Değişiklikleri Kaydet',
        createProgramme: 'Program Oluştur',
        saveFailed: 'Program kaydedilemedi',
        banner: {
          label: 'Kapak görseli',
          choose: 'Bir görsel seçin',
          remove: 'Kapak görselini kaldır',
          none: 'Henüz kapak görseli yok. Üyeler programın adını tenant renginde görür.',
          accepted: 'PNG, WebP veya JPEG, en fazla 2 MB, 800 × 200 ile 6000 × 6000 piksel arası.',
          refused: 'Bu dosya kullanılamaz. En fazla 2 MB ve 800 × 200 ile 6000 × 6000 piksel arasında olan bir PNG, WebP veya JPEG görseli seçin.',
          saveFailed: 'Kapak görseli kaydedilemedi. Tekrar deneyin.',
        },
      },
      manageProgrammes: {
        title: 'Programlar',
        addButton: 'Program Ekle',
        tenant: 'Kiracı',
        loadRolesFailed: 'Kiracı rolleri yüklenemedi',
        loadProgrammesFailed: 'Programlar yüklenemedi',
        table: {
          programmeName: 'Program adı',
          description: 'Açıklama',
          target: 'Hedef',
          startDate: 'Başlangıç tarihi',
          endDate: 'Bitiş tarihi',
        },
        actions: {
          edit: 'Düzenle',
          delete: 'Sil',
        },
        deleteDialog: {
          title: 'Programı Sil',
          message: '"{{programmeName}}" programını silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.',
          delete: 'Sil',
        },
        messages: {
          createSuccess: 'Program başarıyla oluşturuldu',
          updateSuccess: 'Program başarıyla güncellendi',
          deleteSuccess: 'Program başarıyla silindi',
        },
        ongoing: 'Devam Eden',
        loadFailedTitle: 'Programlar okunamadı',
        noOrganisationNotice: 'Programlar bir kuruluşa aittir ve bu hesap hiçbir kuruluşa ait değil.',
        noOrganisationTitle: 'Henüz kuruluş yok',
        rolesUnknownNotice: 'Onlar olmadan bu ekran neyi yönettiğinizi bilemez; bu, hiçbir şeyi yönetmemekle aynı değil.',
        rolesUnknownTitle: 'Rolleriniz okunamadı',
      },
      programmesOverview: {
        title: 'Mevcut Programlar',
        loadFailed: 'Programlar yüklenemedi',
        enrollFailed: 'Programa kayıt olunamadı',
        enroll: 'Kayıt Ol',
        unenroll: 'Kaydı Sil',
        unenrollFailed: 'Program kaydı silinemedi',
        preview: 'Önizleme',
        table: {
          programmeName: 'Program Adı',
          target: 'Hedef',
          programmeStartDate: 'Program Başlangıç Tarihi',
          programmeEndDate: 'Program Bitiş Tarihi',
          enrollmentStatus: 'Kayıt Durumu',
        },
        status: {
          notEnrolled: 'Kayıtlı Değil',
          active: 'Aktif',
          inactive: 'İnaktif',
        },
        previewPanel: {
          enrolledFrom: 'Bu programa şu tarihten itibaren kayıtlısınız:',
          ongoing: 'Günümüz',
        },
        noProgrammesNotice: 'Kuruluşunuz henüz kayıt için bir program açmadı.',
        noProgrammesTitle: 'Henüz program yok',
        programmesUnknownNotice: 'Liste gelmedi; bu, hiç program olmamasıyla aynı şey değil.',
        programmesUnknownTitle: 'Programlar okunamadı',
        retry: 'Yeniden dene',
        close: 'Kapat',
        confirmUnenroll: {
          title: 'Bu programdan ayrılmak istiyor musunuz?',
          body: '{{programme}} programındaki kaydınız silinecek. Daha sonra yeniden kayıt olabilirsiniz.',
          cancel: 'Vazgeç',
          confirm: 'Kaydı Sil',
        },
      },
      observations: {
        addObservation: 'Ölçüm ekle',
        viewToggleLabel: 'Görünüm',
        viewCalendar: 'Takvim',
        viewStack: 'Yığın',
        viewTimeline: 'Zaman çizelgesi',
        filter: {
          title: 'Filtrele',
          label: 'Programlar',
          all: 'Tüm programlar',
        },
        submitting: 'Gönderiliyor...',
        searchBy: 'Şuna göre ara',
        searchValue: 'Arama değeri',
        columns: 'Sütunlar',
        columnsLabel: 'Görüntülenen Sütunları Değiştir',
        eventType: 'Etkinlik türü',
        dateTime: 'Tarih saat',
        measurementType: 'Ölçüm türü',
        value: 'Değer',
        sourceDocument: 'Kaynak belge',
        sourceDocumentDescription: 'Belge aciklamasi',
        actions: 'İşlemler',
        eventTypes: {
          manualInput: 'Manuel Giriş',
          deviceSync: 'Cihaz Senkronizasyonu',
          uploaded: 'Yüklendi',
          coachingSession: 'Koçluk Oturumu',
        },
        validation: {
          eventTypeRequired: 'Etkinlik türü gereklidir',
          dateTimeRequired: 'Tarih ve saat gereklidir',
          invalidDateTime: 'Geçersiz tarih ve saat',
          atLeastOneMeasurement: 'En az bir ölçüm değeri girin',
          invalidValue: 'Geçersiz değer',
          validationFailed: 'Doğrulama başarısız',
          fixErrors: 'Göndermeden önce lütfen tüm doğrulama hatalarını düzeltin',
        },
        messages: {
          noChanges: 'Kaydedilecek değişiklik yok',
          successSingle: 'Gözlem başarıyla kaydedildi',
          successMultiple: 'Tüm gözlem girişleri başarıyla gönderildi!',
          submitError: 'Gözlemler gönderilirken hata',
          updateError: 'Gözlem güncellenirken hata',
          deleteSuccess: 'Gözlem başarıyla silindi',
          removeSuccess: 'Gözlem kaldırıldı',
          deleteError: 'Gözlem silinirken hata',
          loadError: 'Gözlemler yüklenirken hata',
          networkError: 'Ağ hatası oluştu',
          saveError: 'Değişiklikler kaydedilirken hata',
        },
        dialog: {
          deleteTitle: 'Gözlemi Sil',
          deleteMessage: 'Bu gözlem olayını silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.',
          cancel: 'İptal',
          delete: 'Sil',
        },
        dayView: {
          previousDay: 'Önceki gün',
          nextDay: 'Sonraki gün',
          today: 'Bugün',
          noEntries: 'Bu günde kayıtlı gözlem yok',
          edit: 'Düzenle',
          save: 'Kaydet',
          dataTypeNumber: 'Sayı',
          dataTypeText: 'Metin',
          dataTypeBoolean: 'Evet/hayır',
          noProgramme: 'Program yok',
          noValues: 'Kayıtlı değer yok',
          newMeasurementTitle: 'Yeni Ölçüm',
          previewPending: 'Henüz kaydedilmedi',
          programme: 'Program',
          selectProgramme: 'Bir program seçin',
          measurement: 'Ölçüm',
          selectMeasurement: 'Bir ölçüm seçin',
          noMeasurementSelected: 'Bir değer girmeden önce bir ölçüm seçin',
          noProgrammeSelected: 'Bir ölçüm seçmeden önce bir program seçin',
          value: 'Değer',
          viewLabel: 'Görünüm',
          viewDay: 'Gün',
          viewWeek: 'Hafta',
          viewMonth: 'Ay',
          previousWeek: 'Önceki hafta',
          nextWeek: 'Sonraki hafta',
          previousMonth: 'Önceki ay',
          nextMonth: 'Sonraki ay',
          noEntriesRange: 'Bu dönemde kayıtlı gözlem yok',
          legendTitle: 'Programlar',
          legendScheduledLabel: 'Planlanmış ölçüm',
          legendNotInProgramme: 'Bir programda değil',
          dueLabel: 'Yapılacak',
          doneLabel: 'Tamamlandı',
          dueTooltip: '{{measurement}} — {{programme}}',
          recordDue: '{{measurement}} kaydet',
          slotHint: 'Yeni bir şey kaydetmek için takvimde boş bir saate tıklayın',
          moreEvents: '+{{count}} daha',
        },
      },
      settings: {
        title: 'Dil ve bölge ayarları',
        language: 'Dil',
        region: 'Bölge',
        systemOfMeasurement: 'Ölçüm Sistemi',
        timezone: 'Saat Dilimi',
        metricSystem: 'Metrik Sistem',
        imperialSystem: 'İmparatorluk Sistemi',
        usCustomaryUnits: 'Amerika Birleşik Devletleri Geleneksel Birimleri',
        regionInfoTitle: 'Bölge Bilgisi',
        regionInfoText: 'Sayıları, tarihleri ve saatleri yerel formatlarda görüntülemek için bölgenizi seçin (örn., ABD: 1,234.56, 03/07/2025, 5:30 PM; Almanya: 1.234,56, 07.03.2025, 17:30).',
        regionInfo: 'Sayıları, tarihleri ve saatleri yerel formatlarda görüntülemek için bölgenizi seçin.',
        selectLanguage: 'Dil Seç',
        selectRegion: 'Bölge Seç',
        selectMeasurement: 'Ölçüm Sistemi Seç',
        selectTimezone: 'Saat Dilimi Seç',
        preview: 'Önizleme',
        formatExamples: 'Format Örnekleri',
        save: 'Kaydet',
        cancel: 'İptal',
        saving: 'Kaydediliyor...',
        savedSuccessfully: 'Ayarlar başarıyla kaydedildi!',
        saveSuccess: 'Ayarlar başarıyla kaydedildi!',
        warningTitle: 'Değişiklikleri Onayla',
        warningMessage: 'Bu değişiklikler hemen yürürlüğe girecektir. Dil değişiklikleri arayüzü hemen güncelleyecek, bölgesel ve ölçüm ayarları ise görüntülenen tüm verilere uygulanacaktır.',
        confirmSave: 'Değişiklikleri Kaydet',
        languageLabel: 'Dil',
        regionLabel: 'Bölge',
        measurementLabel: 'Ölçüm',
        numberLabel: 'Sayı',
        dateLabel: 'Tarih',
        timeLabel: 'Saat',
        weightLabel: 'Ağırlık',
        heightLabel: 'Boy',
        distanceLabel: 'Mesafe',
        temperatureLabel: 'Sıcaklık',
        saveFailed: 'Ayarlarınız kaydedilemedi.',
        languageSaveFailed: 'Dil seçiminiz kaydedilemedi.',
      },
      actions: {
        add: 'Ekle',
        view: 'Görüntüle',
        edit: 'Düzenle',
        delete: 'Sil',
        save: 'Kaydet',
        cancel: 'İptal',
        close: 'Kapat',
        open: 'Aç',
      },
  recordPage: {
    path: 'Yol',
    general: 'Genel',
  },
  programmePage: {
    measurements: 'Ölçümler',
    dashboards: 'Pano',
    notFoundTitle: 'Bu program bulunamadı',
    notFoundBody: 'Kaldırılmış olabilir veya başka bir kuruluşa ait olabilir.',
    loadFailedTitle: 'Bu program okunamadı',
    loadFailed: 'Birazdan tekrar deneyin.',
  },
  programmeBoards: {
    loading: 'Pano yükleniyor',
    panelTitle: 'Bu programın panosu',
    panelHint: 'Bu programın her üyesi, üzerinde bir blok olduğu anda onu kendi panosunda bulur. Kaydettiğiniz şey hemen görünür.',
    name: 'Ad',
    nameHint: 'Boş bırakılırsa programın adını alır.',
    unsaved: 'Kaydedilmedi',
    save: 'Kaydet',
    discard: 'Değişiklikleri at',
    saved: 'Kaydedildi. Bu programın üyeleri onu şimdi görüyor.',
    saveFailed: 'Pano kaydedilemedi. Tekrar deneyin.',
    emptyTitle: 'Bu pano henüz boş',
    emptyBody: 'Yukarıdan bir blok seçin. Üyeler panoyu üzerinde bir blok olduğunda görür.',
    deniedTitle: 'Bu programın panosunu değiştiremezsiniz',
    deniedBody: 'Bunun için bu programı yapılandırma yetkisi gerekir.',
    loadFailedTitle: 'Pano okunamadı',
    retry: 'Tekrar dene',
    galleryHint: 'Bu panonun altına koymak için bir blok seçin. Her blok bu programın bir ölçümünü gösterir.',
    arrangeHint: 'Bir bloğu tutamağından sürükleyin veya sağ alt köşesinden çekin. Her üye içinde kendi değerlerini görür.',
    noMeasurements: 'Bu program henüz hiçbir ölçüm izlemiyor. Önce Ölçümler sekmesinde bir tane ekleyin.',
  },
  questionnairePage: {
    questions: 'Sorular',
    submissions: 'Gönderiler',
    notFoundTitle: 'Bu anket bulunamadı',
    notFoundBody: 'Kaldırılmış olabilir veya başka bir kuruluşa ait olabilir.',
    loadFailedTitle: 'Bu anket okunamadı',
    loadFailed: 'Birazdan tekrar deneyin.',
  },
  tenantPage: {
    administrators: 'Yöneticiler',
    notFoundTitle: 'Bu kiracı bulunamadı',
    notFoundBody: 'Kaldırılmış olabilir veya adres yanlış olabilir.',
    loadFailedTitle: 'Bu kiracı okunamadı',
    loadFailed: 'Birazdan tekrar deneyin.',
    table: {
      name: 'Ad',
      email: 'E-posta',
    },
    addButton: 'Yönetici ekle',
    remove: 'Kaldır',
    removeTitle: 'Yöneticiyi kaldır',
    removeMessage: '{{name}} artık {{tenant}} kiracısını yönetmeyecek. Hesabı ve kuruluşla bağı kalır.',
    removed: 'Yönetici kaldırıldı',
    added: 'Yönetici eklendi',
    add: {
      title: '{{tenant}} için yönetici ekle',
      person: 'Kişi',
      personRequired: 'Bir kişi seçin',
      nobody: 'Bu kuruluşta seçilebilecek kimse yok.',
      peopleFailed: 'Bu kuruluşun kişileri okunamadı.',
      save: 'Ekle',
      failed: 'Yönetici eklenemedi.',
    },
  },
  grid: {
    noRowsTitle: 'Henüz bir şey yok',
    noRowsNotice: 'Gösterilecek bir şey olduğunda satırlar görünür.',
    noResultsTitle: 'Eşleşen yok',
    noResultsNotice: 'Daha kısa arayın veya filtreleri temizleyin.',
    actions: 'İşlemler',
    edit: 'Düzenle',
    remove: 'Kaldır',
    clearSearch: 'Aramayı temizle',
    cancel: 'İptal',
    save: 'Kaydet',
    saving: 'Kaydediliyor…',
    actionFailed: 'Bu işe yaramadı. Hiçbir şey değiştirilmedi.',
    loadFailedTitle: 'Bu liste okunamadı',
    add: 'Ekle',
    filter: 'Filtrele',
    searchAll: 'Tüm sütunlarda ara',
    sortByField: 'Sırala: {{field}}',
    sortByFieldDirection: 'Sırala: {{field}}, {{direction}}',
    filterWithCount: 'Filtrele ({{count}})',
    newestFirst: 'En yeni önce',
    noResultsFor: '“{{query}}” için sonuç yok',
    clearSearchAndFilters: 'Aramayı ve filtreleri temizle',
    tryAgain: 'Tekrar dene',
    rowsPerPage: 'Sayfa başına satır',
    range: '{{from}}–{{to}} / {{count}}',
    previousPage: 'Önceki sayfa',
    nextPage: 'Sonraki sayfa',
  },
  coaches: {
    title: 'Koçlar',
    subtitle:
      'Kuruluşunuzun sunduğu koçlar. Kime soracağınıza ve ölçümlerinizin ' +
      'neyini görebileceğine siz karar verirsiniz.',
    coachingSubtitle: 'Eşlik ettiğiniz kişiler, size gelen istekler ve rehberin sizi nasıl gösterdiği.',
    unnamedCoach: 'Adı olmayan koç',
    unnamedMember: 'Adı olmayan üye',

    requestPendingChip: 'İstek gönderildi',
    ask: 'Bu koça sor',
    details: 'Ayrıntılar',
    withdrawRequest: 'İsteği geri al',
    access: {
      held: 'Ölçümlerinizden {{see}} tanesini görüyor ve {{record}} tanesini girebiliyor.',
      asked: '{{see}} ölçümü görmek ve {{record}} ölçümü girmek istiyor.',
    },
    cannotAsk: {
      alreadyMyCoach: 'Bu koç ölçümlerinizi zaten görüyor.',
      requestPending: 'İsteğiniz hâlâ yanıt bekliyor.',
      notAccepting: 'Bu koç şu anda yeni kişi kabul etmiyor.',
    },
    askTitle: '{{name}} kişisine sor',
    askExplainer:
      'Bu koçun neyi görebileceğini seçin. Koçlarınız bölümünden her zaman ' +
      'değiştirebilir veya bitirebilirsiniz.',
    measurement: 'Ölçüm',
    maySee: 'Görebilir',
    mayRecord: 'Girebilir',
    maySeeAria: '{{name}} ölçümünü görebilir',
    mayRecordAria: '{{name}} ölçümünü girebilir',
    messageLabel: 'Mesaj (isteğe bağlı)',
    sendRequest: 'İsteği gönder',
    askFailed: 'İstek gönderilemedi.',
    scopesUnavailable: 'Programınızın ölçümleri okunamadı.',
    noProgrammeYet:
      'Henüz bir programa katılmadınız ve paylaşılabilecek şeyler programdan gelir.',
    someUnsharable:
      'Henüz paylaşılamaz: {{names}}. Bu ölçümlerin LOINC kodu yok — bir yöneticiden kod atamasını isteyin.',
    noMeasurementsYet:
      'Programınız henüz bir ölçüm adlandırmıyor, bu yüzden paylaşacak bir şey yok.',
    waitingForYou: 'Yanıtınızı bekliyor',
    stillWaiting: 'Hâlâ yanıt bekliyor',
    earlierRequests: 'Önceki istekler',
    offeredAccess: 'İstenen erişim',
    sharedProgrammes: 'Paylaştığınız programlar',
    askedOn: '{{when}} tarihinde istendi',
    answerableUntil: '{{when}} tarihine kadar yanıtlanabilir',
    expiredOn: '{{when}} tarihinde süresi doldu',
    expired: 'Süresi doldu',
    accept: 'Kabul et',
    decline: 'Reddet',
    declineTitle: 'İsteği reddet',
    declineReasonLabel: 'Gerekçe (isteğe bağlı)',
    actionFailed: 'Bu işlem olmadı.',
    status: {
      pending: 'Yanıt bekliyor',
      accepted: 'Kabul edildi',
      declined: 'Reddedildi',
      withdrawn: 'Geri alındı',
      expired: 'Süresi doldu',
    },
    myListing: 'Koç profiliniz',
    myListingExplainer:
      'Bu profili listeye yalnızca siz koyarsınız. Topluluk paylaşım ' +
      'tercihinizden bağımsızdır.',
    listingSaved: 'Koç profili kaydedildi.',
    saveFailed: 'Profil kaydedilemedi.',
    headlineLabel: 'Kısa açıklama',
    bioLabel: 'Hakkınızda',
    programmesLabel: 'Eşlik ettiğiniz programlar',
    maxMembersLabel: 'En fazla kişi sayısı',
    maxMembersHelp_one: 'Şu anda {{count}} kişiye eşlik ediyorsunuz.',
    maxMembersHelp_other: 'Şu anda {{count}} kişiye eşlik ediyorsunuz.',
    acceptingLabel: 'Yeni kişilere açık',
    publishLabel: 'Kuruluşumda tanıt',
    publishNeedsBoth:
      'Listedeki bir profil kısa bir açıklama ve hakkınızda birkaç söz ister: ' +
      'seçim bunlara bakılarak yapılır.',
    peopleYouFollow: 'Eşlik ettiğiniz kişiler',
    peopleYouFollowExplainer:
      'Birinden neyi görebileceğinize o kişi karar verir.',
    directoryUnknown: 'Liste okunamadı',
    directoryUnknownNotice: 'Lütfen daha sonra tekrar deneyin.',
    onlyYouListedTitle: 'Listedeki tek koç sizsiniz',
    onlyYouListedNotice:
      'Kuruluşunuzdan başka bir koç henüz profil yayınlamadı.',
    noneListedTitle: 'Listede henüz koç yok',
    noneListedNotice:
      'Kuruluşunuzdan bir koç profil yayınladığı anda burada görünür.',
    canAsk: 'Sorabileceğiniz koçlar',
    allAlreadyYoursTitle: 'Henüz başka koç yok',
    allAlreadyYoursNotice: 'Size zaten eşlik eden koçlar yukarıda listelendi. Kuruluşunuzdan başka bir koç profil yayınladığında burada görünür.',
    onlyAccepting: 'Yalnızca yeni kişi kabul edenler',
    search: 'Koç ara',
    noneAcceptingTitle: 'Şu anda kimse yeni kişi kabul etmiyor',
    noneAcceptingNotice: 'Listedeki koçlardan hiçbiri şu anda yeni kişilere açık değil.',
    listingUnknownTitle: 'Koç profiliniz okunamadı',
    listingUnknown: 'Burada gördükleriniz güncel olmayabilir.',
    noListingTitle: 'Koç profiliniz yok',
    noListing:
      'Bu ekranda bir koç, üyelerin gördüğü profili düzenler. Hesabınızda koç rolü yok, bu yüzden burada henüz düzenlenecek bir şey yok.',
    grantsUnknownTitle: 'Koçlarınız okunamadı',
    grantsUnknown: 'Burada gördükleriniz güncel olmayabilir.',
    noneMatchTitle: 'Koç bulunamadı',
    noneMatchNotice: '"{{query}}" ile eşleşen bir şey yok. Bir adın veya programın bir bölümünü deneyin.',

    myCoaches: 'Koçlarınız',
    changeOnCoaches:
      'Bir koçun hangi ölçümlerinizi görebileceğini koçlar sayfasından değiştirirsiniz.',
    whatTheyMaySee: 'Neyi görebilir',
    sinceExplainer:
      'Bu erişimi {{when}} tarihinde verdiniz. Değişiklikler hemen geçerli olur.',
    saveAccess: 'Değişiklikleri kaydet',
    accessSaved: 'Değişiklikler kaydedildi.',
    accessSaveFailed: 'Değişiklik kaydedilemedi.',
    keepOneOrEnd:
      'En az bir ölçüm bırakın ya da erişimi bitirin — böylece koça haber verilir.',
    nothingShared: 'Bu koçla hiçbir şey paylaşılmıyor.',
    accessEndedOn: 'Bu erişim {{when}} tarihinde sona erdi.',
    offerUnreadable:
      'Programınızın ölçümleri okunamadı, bu yüzden yalnızca zaten paylaşılanlar listelendi.',
    endCoaching: 'Erişimi bitir',
    endCoachingTitle: 'Erişimi bitir',
    endCoachingBody:
      '{{name}} bundan sonra ölçümlerinizi göremez. Daha önce kaydedilenler kalır.',
    grantedOn: 'Erişim {{when}} tarihinde verildi',
    endedCoaching: 'Sona eren eşlik',
    endedOn: '{{when}} tarihinde sona erdi',
    revokeFailed: 'Erişim bitirilemedi.',

    tabs: {
      coaches: 'Koçlarım',
      history: 'Geçmiş',
      listing: 'Koç profilim',
      requests: 'Bana gelen istekler',
      members: 'Eşlik ettiğim kişiler',
    },

    noProgrammeTitle: 'Henüz bir programa katılmadınız',
    noProgrammeNotice: 'Bir koç bir programa eşlik eder. Bir programa katıldığınızda, o programa eşlik eden koçlar burada görünür.',
    noHistoryTitle: 'Geriye bakılacak bir şey yok',
    noHistoryNotice: 'Sona eren eşlikler ve sonuçsuz kalan istekler burada saklanır.',
    peopleYouCoached: 'Daha önce eşlik ettiğiniz kişiler',
    noPastMembersTitle: 'Kimse ayrılmadı',
    noPastMembersNotice: 'Eşlik ettiğiniz herkes hâlâ sizinle. Sona eren eşlik burada kaydedilir.',
    noOpenRequestsTitle: 'Bekleyen istek yok',
    noOpenRequestsNotice: 'Biri sizden eşlik etmenizi istediğinde, isteği burada görünür.',
    answeredRequests: 'Yanıtlanan istekler',
    noMembersYetTitle: 'Henüz kimseye eşlik etmiyorsunuz',
    noMembersYetNotice: 'Biri isteğinizi kabul ettiğinde, size gösterdikleriyle birlikte burada görünür.',
    memberUnreadableTitle: 'Bu ölçümler okunamadı',
    memberUnreadable: 'Lütfen birazdan tekrar deneyin.',
    nothingPermittedTitle: 'Gösterilecek bir şey yok',
    nothingPermittedNotice: 'Bu kişinin programları, sizinle paylaşılabilecek hiçbir ölçüm içermiyor.',
    nothingSharedWithYouTitle: 'Henüz bir şey paylaşılmadı',
    nothingSharedWithYouNotice: 'Bu kişi sizinle henüz hiçbir ölçüm paylaşmadı. Paylaşabilecekleri aşağıda listeleniyor.',
    notShared: 'Sizinle paylaşılmadı',
    notSharedNotice: 'Bu kişi bu ölçümü paylaşmadı, bu yüzden hakkında hiçbir şey gösterilmiyor.',
    sourceUnavailable: 'Kaynak yanıt vermedi',
    sourceIncomplete: 'Kısmen okunamadı',
    sourceIncompleteNotice: 'Bu kaynağın gönderdiği bazı değerler okunamadı, bu yüzden burada gösterilenler hepsi değil.',
    sourceSilent: 'Bu değerleri tutan kaynak yanıt vermedi',
    sourceRefused: 'Kaynak sizin için okunamıyor',
    sourceNotReadForYou: 'Bu değerleri tutan kaynak sizin adınıza okunamıyor',
    recordedHere: 'Bu platformda kaydedildi',
    fromSourceAsOf: '{{source}} kaynağından, {{when}} alındı',
    asOfUnknown: 'bilinmeyen bir zamanda',
    mixedSources: 'Değerler {{places}} farklı kaynaktan geliyor, bu yüzden değişim gösterilmiyor.',
    sourcesDegradedTitle: 'Bazı değerler eksik olabilir',
    sourcesDegraded: '{{names}} yanıt vermedi. Orada tutulan değerler bu ekranda eksik olabilir.',
    sourcesRefusedTitle: 'Bazı değerler gösterilemiyor',
    sourcesRefused: '{{names}} sizin adınıza okunamıyor, bu yüzden orada tutulan değerler bu ekranda yok. Bu, o kaynak ile bu platform arasındaki erişimle ilgilidir; bu kişinin sizinle paylaştıklarıyla ilgili değildir.',
    sourceNotConnectedChip: 'Bağlı değil',
    sourceNotConnectedCaption: 'Bu kaynakta tutulan değerleri okumak için kendi hesabınızı bağlayın',
    sourcesNotConnectedTitle: 'Bazı değerleri okumak için bağlanın',
    sourceNotConnected: '{{name}} yalnızca kendi hesabınızla okunabilir. Bir kez bağlayın; bu kişinin sizinle paylaştığı değerler burada gösterilebilir.',
    sourceReconnect: '{{name}} ile bağlantınız sona erdi, bu yüzden orada tutulan değerler bu ekranda yok. Bu kişinin sizinle paylaştıklarını okumak için yeniden bağlanın.',
    connectSource: '{{name}} kaynağını bağla',
    reconnectSource: '{{name}} kaynağını yeniden bağla',
    connectedTitle: '{{source}} ile bağlandı',
    connectedBody: 'Paylaşılan değerleri okumak için bu kişiyi yeniden açın.',
    connectFailedTitle: 'Bağlantı kurulamadı',
    connectFailedBody: 'Hiçbir şey değiştirilmedi. Daha sonra yeniden deneyin.',
    notConnectedTitle: '{{source}} ile bağlı değil',
    connectReasons: {
      refused: '{{source}} oturum açmayı kabul etmedi, bu yüzden hiçbir şey bağlanmadı.',
      no_code: '{{source}} üzerindeki oturum açma bir şey döndürmedi, bu yüzden hiçbir şey bağlanmadı.',
      no_party_id: '{{source}} üzerindeki hesabınızda henüz JLAM kimliği yok, bu yüzden sizi orada adlandıramaz. Hesapları yöneten kişiye sorun.',
      no_person: 'Buradaki hesabınız bir kişiyle ilişkilendirilmemiş, bu yüzden bağlanamaz.',
    },
    sourcesStaleTitle: 'Bazı değerler güncel olmayabilir',
    sourcesStale: '{{names}} yenilenemedi. Son kontrolden bu yana orada kaydedilenler bu ekranda eksik.',
    withheldFromHistory: 'Sizinle paylaşılmadı: {{names}}',
    source: 'Kaynak',
    asOf: 'Alındı',
    here: 'Bu platform',
    lastRecorded: 'Son kayıt {{when}}',
    lastRecordedByYou: 'Son kayıt {{when}}, sizin girdiğiniz',
    noReadingYet: 'Henüz kayıtlı değer yok',
    readOnlyHere: 'Yalnızca görüntüleme',
    newValue: 'Yeni değer',
    unit: 'Birim',
    measuredAt: 'Ölçüm zamanı',
    momentInFuture: 'Bir ölçüm gelecekte tarihlendirilemez.',
    recordedSome_one: '{{count}} değer kaydedildi; kalanı kaydedilemedi.',
    recordedSome_other: '{{count}} değer kaydedildi; kalanı kaydedilemedi.',
    record: 'Kaydet',
    recorded_one: '{{count}} değer kaydedildi.',
    recorded_other: '{{count}} değer kaydedildi.',
    recordFailed: 'Değer kaydedilemedi.',
    nothingToRecord: 'Önce bir değer girin.',
    valueNotANumber: 'Bu ölçüm bir sayı bekliyor.',
    requestSent: '{{name}} kişisine istek gönderildi.',
    requestAccepted: 'Artık {{name}} kişisine eşlik ediyorsunuz.',
    requestDeclined: '{{name}} kişisinin isteği reddedildi.',
    requestWithdrawn: '{{name}} kişisine gönderilen istek geri alındı.',
    accessEnded: '{{name}} artık ölçümlerinizi göremez.',
    findSomeoneYouCoach: 'Eşlik ettiğiniz kişiyi bulun',
    personColumn: 'Kişi',
    sinceColumn: 'Başlangıç',
    trendColumn: 'Eğilim',
    lastActivityColumn: 'Son kayıt',
    lastActivityNever: 'Henüz kayıt yok',
    lastActivityOn: 'Son kayıt {{when}}',
    searchMembers: 'Eşlik ettiğin kişiler arasında ara',
    noMatchesTitle: 'Eşleşen kimse yok',
    noMatchesNotice: 'Daha kısa bir arama dene veya kutuyu boşalt.',
    openMember: '{{name}} kişisini aç',
    caseloadUnknownTitle: 'Eşlik ettiğin kişiler okunamadı',
    caseloadUnknownNotice: 'Lütfen birazdan tekrar dene.',
    jumpToAnother: 'Başka bir kişiye git',
    memberNotInCaseloadTitle: 'Eşlik ettiğin bir kişi değil',
    memberNotInCaseloadNotice: 'Bu kişi listende yok. Eşlik sona ermiş olabilir veya bağlantı eski olabilir.',
    trendNothing: 'Henüz paylaşılan bir şey yok',
    trendInRange_one: '{{count}} hedef aralığında',
    trendInRange_other: '{{count}} hedef aralığında',
    trendToward_one: '{{count}} hedefe yaklaşıyor',
    trendToward_other: '{{count}} hedefe yaklaşıyor',
    trendAway_one: '{{count}} hedeften uzaklaşıyor',
    trendAway_other: '{{count}} hedeften uzaklaşıyor',
    trendTracked_one: '{{count}} ölçüm izleniyor',
    trendTracked_other: '{{count}} ölçüm izleniyor',
    coachingSince: '{{when}} tarihinden beri eşlik ediliyor',
    viewTrends: 'Eğilimler',
    viewHistory: 'Geçmiş',
    recordedAt: 'Kaydedildi',
    value: 'Değer',
    recordedBy: 'Kaydeden',
    you: 'Siz',
    noReadingsTitle: 'Henüz kayıt yok',
    noReadingsNotice: 'Bu kişi için kaydedilen değerler, en yenisi önce olacak şekilde burada görünür.',
  },
  manageRoles: {
    noTenantNotice: 'Roller bir kuruluşa aittir ve bu hesap hiçbir kuruluşa ait değil.',
    noTenantTitle: 'Rolleri gösterilecek kuruluş yok',
  },
  look: {
    title: 'Sembol ve renkler',
    symbol: {
      title: 'Sembol',
      description: 'Gezinme çubuğunda tenant adının yanında her üyeye gösterilir. Kuruluşa aittir, bu yüzden kuruluşun tüm tenant’ları aynı sembolü gösterir.',
      preview: 'Sembolün gezinme çubuğundaki görünümü',
      none: 'Henüz sembol yok. Üyeler yalnızca tenant adını görür.',
      accepted: 'PNG veya WebP, en fazla 512 KB ve en az 64 × 64 piksel.',
      choose: 'Bir görsel seçin',
      save: 'Sembolü kaydet',
      saved: 'Sembol kaydedildi.',
      remove: 'Sembolü kaldır',
      removed: 'Sembol kaldırıldı.',
      refused: 'Bu dosya kullanılamaz. En fazla 512 KB ve en az 64 × 64 piksel olan bir PNG veya WebP görseli seçin.',
      error: 'Sembol kaydedilemedi. Tekrar deneyin.',
    },
    profiles: {
      title: 'Renk profilleri',
      description: 'Üyeler kendileri bir profil seçene kadar varsayılan profili görür. MLP’nin standart profilleri her zaman sizinkilerin yanında sunulur.',
      standard: 'MLP standart profili',
      own: 'Bu tenant’ın profili',
      default: 'Varsayılan',
      makeDefault: 'Varsayılan yap',
      defaultSaved: '{{name}} artık varsayılan profil.',
      edit: 'Renkleri düzenle',
      history: 'Geçmiş',
      add: 'Profil ekle',
      newName: 'Profilin adı',
      create: 'Profili kaydet',
      added: '{{name}} sürüm 1 olarak eklendi.',
      duplicateName: 'Bu tenant’ta bu adla bir profil zaten var. Başka bir ad seçin.',
      loadError: 'Renk profilleri yüklenemedi. Tekrar denemek için sayfayı yeniden yükleyin.',
      saveError: 'Değişiklik kaydedilemedi. Tekrar deneyin.',
    },
    editor: {
      title: '{{name}} renkleri',
      newTitle: 'Yeni renk profili',
      hexLabel: '{{role}} için onaltılık değer',
      variants: 'Daha açık, ana ve daha koyu varyant, ana varyant üzerindeki metin rengiyle',
      textSample: 'Aa',
      contrastIntro: 'Bu renklerle metin zor okunur. Aşağıda belirtilen rengi değiştirin:',
      contrastFailure: '{{role}}, {{pairing}}: {{ratio}}:1, oysa en az {{required}}:1 gerekir',
      pairing: {
        textOnColour: 'bu renk üzerindeki metin',
        linkOnPaper: 'beyaz üzerinde bağlantı metni olarak',
        linkOnPage: 'sayfa arka planında bağlantı metni olarak',
      },
      save: 'Yeni sürüm olarak kaydet',
      saved: 'Sürüm {{version}} olarak kaydedildi.',
      reset: 'Meridian’a sıfırla',
      close: 'Kapat',
    },
    history: {
      title: '{{name}} geçmişi',
      version: 'Sürüm {{version}}',
      savedBy: '{{when}}, {{who}} tarafından',
      savedAt: '{{when}}',
      current: 'Kullanımda',
      rollBack: 'Bu sürüme geri dön',
      rolledBack: 'Geri alındı. Sürüm {{version}} olarak kaydedildi.',
      loadError: 'Geçmiş yüklenemedi.',
      rollBackError: 'Geri alma kaydedilemedi. Tekrar deneyin.',
    },
    preview: {
      title: 'Önizleme',
      navigationCurrent: 'Pano',
      navigationOther: 'Ölçümler',
      button: 'Kaydet',
      secondButton: 'Ekle',
      link: 'Bir bağlantı',
      chart: 'Hedef aralığıyla birlikte bir haftalık ölçüm',
    },
    roles: {
      primary: {
        name: 'Ana renk',
        hint: 'Gezinme, düğmeler, bağlantılar ve odak',
      },
      secondary: {
        name: 'İkinci renk',
        hint: 'İkincil düğmeler ve vurgular',
      },
      success: {
        name: 'Aralıkta',
        hint: 'Olması gereken yerdeki bir değer ve başarılan şey',
      },
      warning: {
        name: 'Aralık dışında',
        hint: 'Hedefinden uzaklaşan bir değer',
      },
      error: {
        name: 'Hata',
        hint: 'Hatalar ve şimdi dikkat gerektirenler',
      },
      info: {
        name: 'Bilgi',
        hint: 'Nötr bildirimler',
      },
    },
    standard: {
      meridian: 'Meridian',
      lagune: 'Lagün',
      classic: 'Klasik',
    },
    choice: {
      title: 'Renk profili',
      description: 'Uygulamanın size nasıl göründüğü. Seçiminiz profilinizi kaydettiğinizde uygulanır ve diğer cihazlarınızda da geçerlidir.',
      followTenant: '{{tenant}} varsayılanı ({{name}})',
      followMeridian: 'MLP varsayılanı (Meridian)',
      loadError: 'Renk profilleri yüklenemedi.',
    },
  },
  valueDetail: {
    title: 'Bu değer nereden geliyor',
    traceTitle: 'Bu değerin izi',
    loading: 'Bu değerin kaynağı okunuyor',
    missing: 'Bu numarayla bir değer yok.',
    failed: 'Bu değerin kaynağı okunamadı.',
    retry: 'Tekrar dene',
    value: 'Değer',
    time: 'Zaman',
    notKnown: 'Bu değer hakkında daha fazlası bilinmiyor.',
    recorded: 'Kaydedildiği gibi',
    code: 'Kod',
    codeSystem: 'Kod sistemi: {{system}}',
    source: 'Kaynak',
    sources: {
      manualInput: 'Senin girdiğin',
      deviceSync: 'Bağlı bir kaynaktan',
      uploaded: 'Bir belgeden',
      coachingSession: 'Bir koçtan',
    },
    shownAs: 'Şöyle gösterilir',
    converted: 'Nasıl dönüştürüldü',
    noConversion: 'Dönüşüm yok: kaydedildiği gibi gösterilir.',
    conversion: {
      algebra: '1 {{from}} = {{factor}} {{to}}, {{date}} tarihinde onaylandı.',
      molarMass: '1 {{from}} = {{factor}} {{to}}, {{analyte}} mol kütlesi üzerinden ({{mass}} g/mol, kaynak: {{source}}), {{date}} tarihinde onaylandı.',
    },
    reference: 'Referans',
    changedSince: 'O zamandan beri değişti',
    notChanged: 'Kod o zamandan beri değişmedi.',
    laterRelease: 'Değer kaydedildikten sonra daha yeni bir sürüm bu kodu değiştirdi.',
    change: '{{field}}: {{from}} → {{to}} ({{date}})',
    showFullOrigin: 'Tam kaynağı göster',
    close: 'Kapat',
    graphLabel: 'Okumalar. Aralarında gezinmek için ok tuşlarını kullan.',
    graphOpenHint: 'Açmak için Enter\'a bas.',
  },
  groupingLevels: {
    label: 'Değerlerin ne kadar geniş sayıldığı',
    loading: 'Düzeyler okunuyor',
    loadFailed: 'Düzeyler okunamadı. Kayıtlı düzey olduğu gibi kalır.',
    THIS_CODE: {
      name: 'Yalnızca bu kod',
      help: 'Yalnızca tam olarak bu kodla kaydedilen değerler sayılır.',
    },
    ANY_METHOD: {
      name: 'Aynı şey, yöntem fark etmez',
      help: 'Aynı şeyin değerleri, evde veya klinikte ölçülmüş olsun, sayılır.',
    },
  },
    };

export default { translation };
